"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateNurseLicensesDto = instanceOfCreateNurseLicensesDto;
exports.CreateNurseLicensesDtoFromJSON = CreateNurseLicensesDtoFromJSON;
exports.CreateNurseLicensesDtoFromJSONTyped = CreateNurseLicensesDtoFromJSONTyped;
exports.CreateNurseLicensesDtoToJSON = CreateNurseLicensesDtoToJSON;
exports.CreateNurseLicensesDtoToJSONTyped = CreateNurseLicensesDtoToJSONTyped;
const CreateNurseLicenseDto_1 = require("./CreateNurseLicenseDto");
/**
 * Check if a given object implements the CreateNurseLicensesDto interface.
 */
function instanceOfCreateNurseLicensesDto(value) {
    if (!('licenses' in value) || value['licenses'] === undefined)
        return false;
    return true;
}
function CreateNurseLicensesDtoFromJSON(json) {
    return CreateNurseLicensesDtoFromJSONTyped(json, false);
}
function CreateNurseLicensesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'licenses': (json['licenses'].map(CreateNurseLicenseDto_1.CreateNurseLicenseDtoFromJSON)),
    };
}
function CreateNurseLicensesDtoToJSON(json) {
    return CreateNurseLicensesDtoToJSONTyped(json, false);
}
function CreateNurseLicensesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'licenses': (value['licenses'].map(CreateNurseLicenseDto_1.CreateNurseLicenseDtoToJSON)),
    };
}
//# sourceMappingURL=CreateNurseLicensesDto.js.map